import { useStore } from 'src/onboarding/store/store';

/**
 * The user's selfie for display.
 *
 * The base64 the camera/library produced is deliberately NOT persisted — a
 * selfie is megabytes and would blow the localStorage quota (see partialize in
 * store.ts). So after a page reload it is gone and any screen reading it alone
 * would silently drop the photo. PhotoCapture also uploads the file and stores
 * the returned URL, which IS persisted: that copy survives the reload.
 *
 * Returns undefined only when the upload never landed either — the caller is
 * expected to render without the photo in that case.
 */
export const useFrontPhoto = (): string | undefined => {
  const base64 = useStore((s: any) => s.hairstyleWomenFront) as string | undefined;
  const uploadedUrl = useStore((s: any) => s.hairstyleWomenFrontUrl) as string | undefined;

  return base64 || uploadedUrl;
};
